<template>
	<div id="app">
		<div class="loader-wrapper" :class="{ loderhide: !show }">
			<div class="loader-index">
				<span></span>
			</div>
		</div>

		<!--<Main/>-->
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: "app",
	data() {
		return {
			show: true,
		};
	},
	mounted() {
		this.timeOut();
	},
	methods: {
		timeOut() {
			var self = this;
			setTimeout(function () {
				self.show = false;
			}, 1000);
		},
	},
};
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
	display: none;
}

@import "./assets/css/rubik.css";
@import "./assets/css/roboto.css";
@import "./assets/css/custom.css";
</style>

